import { memo } from 'react';

import withComponentName from '../../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';
import ButtonComponent from '../../../../Buttons/ButtonComponent';
import DashedLineComponent from '../../../../DashedLineComponent';
import AnimatedCircleComponent from '../../../../AnimatedCircleComponent';

import integratedImage from '../../../../../assets/homepage/integrated-api.svg';

export const IntegratedNewsSection = ({
  sendHomePageActions,
  windowWidth,
  centerForLine,
  width,
}) => (
  <section className={Styles.integrate_news}>
    <div className={Styles.background}>
      <DashedLineComponent
        section="integrate_news"
        coords={
          width <= 1160 ? `M${centerForLine},140 v1030`
            : `M${centerForLine},280 v1030`
        }
      />
      <AnimatedCircleComponent
        countCircles={windowWidth > 1160 ? 3 : 2}
        inSection
        className={Styles.anim_circle}
      />
    </div>
    <div className={Styles.integrate_image}>
      <img src={integratedImage} alt="" />
    </div>
    <div className={Styles.integrate_description}>
      <div className={Styles.description_container}>
        <h3 className={`${Styles.title} text-uppercase`}>
          Access content and analytics through our API
        </h3>
        <p className={Styles.institutions}>
          Integrate our API for seamless algorithmic decision making and market awareness.
        </p>
        <p className={Styles.institutions}>
          Add content to your platforms to inform and engage your users and clients
          with real-time and relevant financial content.
        </p>
        <div className={Styles.button_container}>
          <ButtonComponent
            checkEvent={() => sendHomePageActions('Try our API')}
            path="/financial-news-api"
            value="Learn More"
            short
          />
        </div>
      </div>
    </div>
    <div className={Styles.button_container_mobile}>
      <ButtonComponent
        path="/financial-news-api"
        value="Try Our API"
        short
      />
    </div>
  </section>
);

export default withComponentName(memo(IntegratedNewsSection));
